import React from 'react';
import { RecoilRoot } from 'recoil';
import { styled } from '@mui/material/styles';

import Fieldset from '@powerednow/components/fields/Fieldset';
import Toast from '@powerednow/components/toast/toast';
import { CreateExtComponent } from '@powerednow/client-shared/Components/react/React';
import CompanyWorkflowList from 'FieldServices/react/features/workflow/companyWorkflowList';
import InvoiceReminderListItemCard
    from 'FieldServices/react/features/workflow/ListItemCards/InvoiceReminderListItemCard';
import QuoteReminderListItemCard from 'FieldServices/react/features/workflow/ListItemCards/QuoteReminderListItemCard';
import { Box } from '@mui/material';

const StyledFieldset = styled(Fieldset)(() => ({
    '&': {
        padding: '0 var(--basic-element-margin)',
    },
}));

function DocumentReminders() {
    return (
        <RecoilRoot>
            <Box className="l-desktop_Centered">
                <StyledFieldset
                    title="Invoice reminders"
                    className="page-padding"
                    fields={[
                        <p>
                            Up to 3 reminders can be set up to chase unpaid invoices after their due date. Each reminder
                            can be configured to be sent at different times after the due date and to use different
                            wording.
                        </p>,
                        <p>
                            This will automatically chase your customer if an invoice is not marked as paid. You MUST
                            record payments against invoices as soon as they are received or you will infuriate your
                            customers.
                        </p>,
                        <CompanyWorkflowList
                            workflowIdFilter="invoice-reminder"
                            addButtonTitle="Add new reminder"
                            ListItemCard={InvoiceReminderListItemCard}
                            editPanelVisible={false}
                        />,
                    ]}
                />
                <StyledFieldset
                    title="Quote reminders"
                    fields={[
                        <p>
                            Up to 3 reminders can be set up to chase quotes/estimates after the date they have been
                            sent.
                            Each reminder can be configured to be sent a fixed number of days after the quote/estimate
                            was sent and to use its own wording.
                        </p>,
                        <CompanyWorkflowList
                            workflowIdFilter="quote-reminder"
                            addButtonTitle="Add new reminder"
                            ListItemCard={QuoteReminderListItemCard}
                            editPanelVisible={false}
                        />,
                    ]}
                />
                <Toast />
            </Box>
        </RecoilRoot>
    );
}

export default DocumentReminders;
export const ExtDocumentReminders = CreateExtComponent('FieldServices.view.settings.notification.DocumentReminders.DocumentReminders', DocumentReminders, { alias: 'widget.ExtDocumentReminders' });
